import { render, staticRenderFns } from "./applicationType.vue?vue&type=template&id=bb0d74de&"
import script from "./applicationType.vue?vue&type=script&lang=js&"
export * from "./applicationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports